export default [
  {
    name: 'Mazda RX4',
    x: 21,
    y: 110,
  },
  {
    name: 'Mazda RX4 Wag',
    x: 21,
    y: 110,
  },
  {
    name: 'Datsun 710',
    x: 22.8,
    y: 93,
  },
  {
    name: 'Hornet 4 Drive',
    x: 21.4,
    y: 110,
  },
  {
    name: 'Hornet Sportabout',
    x: 18.7,
    y: 175,
  },
  {
    name: 'Valiant',
    x: 18.1,
    y: 105,
  },
  {
    name: 'Duster 360',
    x: 14.3,
    y: 245,
  },
  {
    name: 'Merc 240D',
    x: 24.4,
    y: 62,
  },
  {
    name: 'Merc 230',
    x: 22.8,
    y: 95,
  },
  {
    name: 'Merc 280',
    x: 19.2,
    y: 123,
  },
  {
    name: 'Merc 280C',
    x: 17.8,
    y: 123,
  },
  {
    name: 'Merc 450SE',
    x: 16.4,
    y: 180,
  },
  {
    name: 'Merc 450SL',
    x: 17.3,
    y: 180,
  },
  {
    name: 'Merc 450SLC',
    x: 15.2,
    y: 180,
  },
  {
    name: 'Cadillac Fleetwood',
    x: 10.4,
    y: 205,
  },
  {
    name: 'Lincoln Continental',
    x: 10.4,
    y: 215,
  },
  {
    name: 'Chrysler Imperial',
    x: 14.7,
    y: 230,
  },
  {
    name: 'Fiat 128',
    x: 32.4,
    y: 66,
  },
  {
    name: 'Honda Civic',
    x: 30.4,
    y: 52,
  },
  {
    name: 'Toyota Corolla',
    x: 33.9,
    y: 65,
  },
  {
    name: 'Toyota Corona',
    x: 21.5,
    y: 97,
  },
  {
    name: 'Dodge Challenger',
    x: 15.5,
    y: 150,
  },
  {
    name: 'AMC Javelin',
    x: 15.2,
    y: 150,
  },
  {
    name: 'Camaro Z28',
    x: 13.3,
    y: 245,
  },
  {
    name: 'Pontiac Firebird',
    x: 19.2,
    y: 175,
  },
  {
    name: 'Fiat X1-9',
    x: 27.3,
    y: 66,
  },
  {
    name: 'Porsche 914-2',
    x: 26,
    y: 91,
  },
  {
    name: 'Lotus Europa',
    x: 30.4,
    y: 113,
  },
  {
    name: 'Ford Pantera L',
    x: 15.8,
    y: 264,
  },
  {
    name: 'Ferrari Dino',
    x: 19.7,
    y: 175,
  },
  {
    name: 'Maserati Bora',
    x: 15,
    y: 335,
  },
  {
    name: 'Volvo 142E',
    x: 21.4,
    y: 109,
  },
];
